
export const storage = {
  getUserFromStorage: (): any => {
    const user = window.localStorage.getItem("user");
    return user ? JSON.parse(user) : null;
  },

  setUserInStorage: (user: any) => {
    return window.localStorage.setItem("user", JSON.stringify(user));
  },

  getTokenFromStorage: (): string | null => {
    return window.localStorage.getItem("token");
  },

  setTokenInStorage: (token: string) => {
    return window.localStorage.setItem("token", token);
  },
};
